import request from '@/utils/request'

export function selectList () {
  return request({
    url: '/api/videoexplore?page=' + sessionStorage.getItem('videPage'),
    method: 'get'
  })
}

export function rankList (type, page) {
  return request({
    url: '/api/rank',
    method: 'get',
    params: {
      type,
      page
    }
  })
}

export function adList () {
  return request({
    url: '/api/adinfo/EXPLODE/0'
  })
}

export function rankPageViewList (sort = 'day') {
  return request({
    url: `/api/rank/pageviews/${sort}`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/API/find.js